<script setup>
import { CheckCircleOutlined, SaveOutlined } from '@ant-design/icons-vue';

defineProps({
    isReadonly: { type: Boolean, default: false },
    isConsultationMode: { type: Boolean, default: false },
    versionSource: { type: Number, default: 0 },
    finishLoading: { type: Boolean, default: false },
    flatSaveLoading: { type: Boolean, default: false }
});

const emit = defineEmits(['save-draft', 'finish', 'back']);
</script>

<template>
    <footer v-if="!isReadonly" class="admin-editor-footer">
        <div class="admin-editor-footer__actions">
            <a-button
                class="admin-editor-btn admin-editor-btn--secondary"
                :loading="flatSaveLoading"
                @click="emit('save-draft')"
            >
                <template #icon><SaveOutlined /></template>
                {{
                    isConsultationMode
                        ? (versionSource === 2 ? '儲存諮詢版' : '儲存盤點版')
                        : '儲存草稿'
                }}
            </a-button>
            <a-button
                v-if="isConsultationMode"
                type="primary"
                class="admin-editor-btn admin-editor-btn--primary"
                :loading="finishLoading"
                @click="emit('finish')"
            >
                <template #icon><CheckCircleOutlined /></template>
                完成版本
            </a-button>
        </div>
    </footer>
</template>

<style scoped>
.admin-editor-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 12px;
    padding: 12px 14px;
    border: 1px solid #e8e2d6;
    border-radius: 12px;
    background: linear-gradient(180deg, #fffdf8 0%, #f6f1e6 100%);
}

.admin-editor-footer__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>
